import { FC, HTMLAttributes, memo, useState, useEffect } from 'react';
import cn from 'classnames';

import * as Meta from '@Queries/Meta';
import * as Cart from '@Queries/Cart';
import usePromoSettings from '@Promo/usePromoSettings';
import data from './data';
import Cross from '@UI/Cross';
import Condition from '@Promo/elems/Condition';
import ClipboardCopy from './elems/ClipboardCopy';
import PopupsStore from '@Stores/Popups';
import styles from './IndividualDiscountPopup.module.css';

export interface IndividualDiscountPopupProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
}

const IndividualDiscountPopup: FC<IndividualDiscountPopupProps> = ({ className, ...restProps }) => {
  const { header, subtitle, promocode, conditionFebruary, conditionMarch, endDate } = data.popup;
  const [showPopup, setShowPopup] = useState(false);
  const cart = Cart.useCart();
  const meta = Meta.useMeta();
  const { country } = meta.data;
  const isKAZ = country === 'KAZ';
  const isEmptyCard = cart.data?.count === 0;
  const { now } = usePromoSettings();
  const IsEnded = endDate > now;
  const march = now.getMonth() === 2;
  const isShowPopup = showPopup && isKAZ && isEmptyCard;
  const condition = march ? conditionMarch : conditionFebruary;

  const toggle = () => {
    setShowPopup(!showPopup);
  };

  const handelClick = (e) => {
    e.stopPropagation();
  };

  useEffect(() => {
    if (!sessionStorage.popupModal) {
      const timer = setTimeout(() => {
        setShowPopup(true);
        sessionStorage.popupModal = 1;
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, []);

  useEffect(() => {
    PopupsStore.openPopup();
  }, []);

  return isShowPopup && IsEnded ? (
    <div {...restProps} className={cn(styles.popup, className)} onClick={toggle}>
      <div className={styles.container} onClick={handelClick}>
        <Cross className={styles.iconClose} onClick={toggle} />
        <div className={styles.contentWrapper}>
          <div className={styles.textWrapper}>
            <div className={styles.header}>{header}</div>
            <div className={styles.subtitle}>{subtitle}</div>
            <ClipboardCopy copyText={promocode} />
            <Condition text={condition} className={styles.condition} />
          </div>
        </div>
        <div className={styles.bg} />
      </div>
    </div>
  ) : null;
};

export default memo(IndividualDiscountPopup);
